import { biaIpTypeOptions } from "@/common/const";
import {
  includedOptions,
  wiaAccessTechOptions,
} from "@/common/const/filter-options";
import { wiaInterfaceType } from "@/common/const/filter-options/wiaInterfaceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const wiaResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "downloadSpeed",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    patternMessage: "Download speed must be between 0.128 and 10,000 Mbps",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    type: "select",
    attribute: "IP",
    required: true,
    options: biaIpTypeOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "uploadSpeed",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    patternMessage: "Upload speed must be between 0.128 and 10,000 Mbps",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    type: "select",
    attribute: "CPE",
    required: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "dataLimitType",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    options: [
      { label: "Capped", value: "capped" },
      { label: "Unlimited", value: "unlimited" },
    ],
  },
  {
    type: "select",
    attribute: "interface",
    required: true,
    options: wiaInterfaceType,
    readonly: false,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "dataLimitGB",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^([1-9]\d{0,5})(\.\d{1,2})?$/,
    patternMessage: "Data Limit must be a positive number in GB",
  },
  {
    type: "text",
    attribute: "SlaUptime",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(100(\.0{1,3})?|[0-9]?[0-9](\.\d{1,3})?)$/,
    patternMessage: "SLA Uptime must be a number between 0 and 100%",
  },
  {
    type: "select",
    attribute: "AccessTechnology",
    required: true,
    options: wiaAccessTechOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "SlaMTTR",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^([1-9]\d{0,2}|1000)(\.\d{1,2})?$/,
    patternMessage: "SLA MTTR must be a number between 1 and 1000 hours",
  },
  {
    type: "text",
    inputClassElement: "border-gray-surface bg-white",
    attribute: "provider",
    required: true,
    pattern: /^[a-zA-Z0-9\s\-.,]{2,100}$/,
    patternMessage: "Provider must be 2–100 characters, no special characters",
  },
  {
    type: "select",
    attribute: "isLocalTax",
    required: true,
    options: includedOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "overageCharges",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d+(\.\d{1,2})?$/,
    patternMessage: "Overage charges must be a positive number",
  },
  {
    type: "text",
    attribute: "localTax",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(100(\.0+)?|[0-9]?\d(\.\d+)?|0)$/,
    patternMessage: "Local Tax must be a number between 0 and 100%",
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];

export default wiaResStrategy;
